import { HiikerMapStyle } from '../../utils/models/MapStyles';

/**
 * The style URL the peak 3D map boots with: the user's currently-selected map
 * style (pro-aware), matching every other map surface. Kept out of peak3d.ts
 * (which runs DOM/side-effect code on import) so the style selection is
 * unit-testable in isolation.
 */
export function peak3dStyleUrl(isPro: boolean): string {
  return HiikerMapStyle.getCurrentStyle(isPro).styleUrl;
}
